/**
 * Normalizes tenant node list payloads from GET /graph-context and node endpoints.
 * Backends may return a bare array or paginated / wrapped shapes.
 */
export const extractNodeListFromApiPayload = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];

  const nestedData = payload.data;
  if (Array.isArray(nestedData)) return nestedData;

  const candidates = [
    payload.content,
    payload.items,
    payload.results,
    payload.rows,
    payload.facilities,
    payload.supplierFacilities,
    payload.supplier_facilities,
    payload.products,
    payload.logistics,
    payload.geographies,
    payload.commodities,
    payload.graphRelationships,
    payload.graph_relationships,
    nestedData?.content,
    nestedData?.items,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate;
  }

  return [];
};
